import i18n from "@/i18n.ts";
import { ApiAggregationDate } from "@skailer-com/uikit";

export enum AnalyticReportTypes {
  recruitingStageFlow = "ATS: Stage flow report",
  recruitingSourceEfficiency = "ATS: Source Efficiency",
  recruitingCloseTime = "ATS: Closing Time",
  recruitingDisqualificationReasons = "ATS: Disqualification Reasons",
  employeesHeadcount = "Employees: Headcount",
  employeesSalary = "Employees: Salary",
  peopleAnalytics = "Employees: People Analytics",
  timeOffBalancesSummary = "Time Off: Balances Summary",
  timeOffBalancesByCategory = "Time Off: Balances Category",
  timeOffHistory = "Time Off: History",
  timeOffPolicy = "Time Off: Policy",
  employeesChart = "Employees Chart",
  formScale = "Form Scale",
  formTemplate = "Form template",
  surveySummaryChart = "Survey Summary Chart",
}

export enum ApiAnalyticsAggregationDate {
  day = "day",
  week = "week",
  month = "month",
  quarter = "quarter",
  year = "year",
}

export enum ApiExportFormat {
  page = "page",
  xlsx = "xlsx",
  csv = "csv",
  pdf = "pdf",
}

export const getAggregationDateTitle = (status: ApiAnalyticsAggregationDate) => {
  const statusNames: Record<ApiAnalyticsAggregationDate, string> = {
    [ApiAnalyticsAggregationDate.day]: i18n.t("common:group_period_by_day"),
    [ApiAnalyticsAggregationDate.week]: i18n.t("common:group_period_by_week"),
    [ApiAnalyticsAggregationDate.month]: i18n.t("common:group_period_by_month"),
    [ApiAnalyticsAggregationDate.quarter]: i18n.t("common:group_period_by_quarter"),
    [ApiAnalyticsAggregationDate.year]: i18n.t("common:group_period_by_year"),
  };

  return statusNames[status];
};

export const getApiAggregationDateTitle = (status: ApiAggregationDate) => {
  const statusNames: Record<ApiAnalyticsAggregationDate, string> = {
    [ApiAggregationDate.day]: i18n.t("common:group_period_by_day"),
    [ApiAggregationDate.week]: i18n.t("common:group_period_by_week"),
    [ApiAggregationDate.month]: i18n.t("common:group_period_by_month"),
    [ApiAggregationDate.quarter]: i18n.t("common:group_period_by_quarter"),
    [ApiAggregationDate.year]: i18n.t("common:group_period_by_year"),
  };

  return statusNames[status];
};
